import type { ActionContext } from 'vuex'
import type { ActionClass, Dictionary, Filter, Pagination, SearchState } from '../../../models'
import type {
  BrowseResponse,
  BrowseService,
} from '../../../modules/browse/services/types/browse-service'
import { CONTAINER } from '../../../config'
import { TYPES } from '../../../config/inversify.types'

export class BrowseAction implements ActionClass {
  static async execute(
    this: void,
    _actionContext: ActionContext<SearchState, any>,
    payload: {
      attribute: { id: string; value: string }
      filters: Dictionary<Filter>
      pagination: Pagination
      params?: Dictionary
      debug?: boolean
    },
  ): Promise<BrowseResponse> {
    const browseService = CONTAINER.get<BrowseService>(TYPES.BrowseService)
    return browseService.browse(payload)
  }
}
